import { FC, ReactNode } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { MplusPopup } from 'entities/mplus/ui/mplus-popup'

import { priceShow } from 'shared/lib/priceShow'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import s from './styles.module.scss'

interface Props {
  payNow?: string
  monthlyPrice?: string
}

interface RowProps {
  title: ReactNode
  value: string
  className?: string
  onClick?: () => void
}

const TotalRow: FC<RowProps> = ({ title, value, className, onClick }) => {
  return (
    <p
      className={clsx(s.row, className)}
      onClick={onClick}
    >
      {title}

      <span>{value} &#8384;</span>
    </p>
  )
}

export const MInstalmentTotal: FC<Props> = ({ payNow = '0', monthlyPrice }) => {
  const { t } = useTranslation()

  const { openDialog } = useDialogBottomSheet()

  const onOpenMonthlyInfo = () => {
    openDialog({
      child: (
        <MplusPopup
          title={t('mplus.monthly_payment')}
          description={t('mplus.mplus_each_month_pay_info_desc', {
            price: priceShow(monthlyPrice),
          })}
        />
      ),
      isDialog: false,
    })
  }

  return (
    <div className={s.container}>
      <TotalRow
        className="bold-16"
        title={t('mplus.to_pay_current')}
        value={priceShow(payNow)}
      />

      <TotalRow
        className="medium-14"
        onClick={onOpenMonthlyInfo}
        value={priceShow(monthlyPrice)}
        title={
          <span className={s.info}>
            {t('mplus.from_next_month')}

            <AppIcon
              width={16}
              height={16}
              id={AllIcons.INFO}
              className={s.icon}
            />
          </span>
        }
      />
    </div>
  )
}
